export const FillType = Object.freeze({
  COLOR: "color",
  IMAGE: "image",
  VIDEO: "video"
});
